import { components, proxy } from '@/utils'

import render from './render'

export default {
  name: components.tabs,

  mixins: [ proxy() ],

  props: {
    tabs: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  mounted() {
    if (Array.isArray(this.tabs) && this.tabs.length) {
      this.setCurrentTab(this.tabs[0].key)
    }
  },

  methods: {
    setCurrentTab(key) {
      if (this.proxy !== key) {
        this.proxy = key
      }
    }
  },

  render
}
